module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/private-library@3x_6c44b1.jpg";